module.exports = "/icon-lg-monitor.svg?805c38";